var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsageCountIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21028_37739)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.7613 6.77078C15.0705 8.28833 14.8501 9.86601 14.1369 11.2407C13.4237 12.6155 12.2608 13.7041 10.842 14.3252C9.42327 14.9463 7.83448 15.0622 6.34062 14.6536C4.84675 14.2451 3.53809 13.3367 2.63289 12.0801C1.72769 10.8234 1.28065 9.29443 1.36633 7.74807C1.45201 6.20172 2.06523 4.73147 3.10372 3.58251C4.14221 2.43356 5.5432 1.67534 7.07306 1.43432C8.60292 1.19329 10.1692 1.48402 11.5106 2.25802",
    stroke: "#00C49A",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.09375 7.44784L8.125 9.47909L14.8958 2.70825",
    stroke: "#00C49A",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21028_37739"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.25,
    height: 16.25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsageCountIcon);
export default __webpack_public_path__ + "static/media/usage-count-icon.860a9b197862a25933cf3bed00d18965.svg";
export { ForwardRef as ReactComponent };